import React, { useState } from 'react'
import { ReactComponent as SubtitlesSVG } from "assets/player/subtitles.svg";
import { Button } from '../Button';
import { Option, SubtitlesMenu } from './styles';
import { useTranslation } from 'react-i18next';

const Subtitles = ({ current, subtitles, onChange }) => {

  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false);

  const toogleIsOpen = () => setIsOpen(prev => !prev)

  const handleSubtitles = (srcLang) => {
    const tracks = document.getElementsByTagName('track')
    const tracksDRM = document.getElementsByClassName('vjs-text-track-cue')

    Array.from(tracks).map((trackItem) => {
      if (trackItem.track.language !== srcLang) {
        return trackItem.track.mode = 'hidden';
      } else {
        return trackItem.track.mode = 'showing';
      }
    });

    Array.from(tracksDRM).map((trackItem) => {
      if (trackItem.lang !== srcLang) {
        return trackItem.style.display = 'none';
      } else {
        return trackItem.style.display = 'unset';
      }
    });

    onChange(srcLang);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      {isOpen && (
        <>
          <SubtitlesMenu>
            <p>{t('subtitles')}</p>

            <Option
              $isActive={!current}
              onClick={() => handleSubtitles(null)}
            >
              {t('disabledPlural')}
            </Option>

            {subtitles.map(sub => (
              <Option
                key={sub.uuid}
                $isActive={sub.srcLang === current}
                onClick={() => handleSubtitles(sub.srcLang)}
              >
                {sub.label}
              </Option>
            ))}
          </SubtitlesMenu>
        </>
      )}

      <Button onClick={toogleIsOpen}>
        <SubtitlesSVG height={30} width={30} />
      </Button>
    </div>
  )
}

export default Subtitles